	/**
	 * @deprecated
	 * NeedWaitHander: handles the message of "TYPE_CHAT_NEED_WAIT"
	 * When constructed, the period and message are checked and if both defined the handler is enabled.
	 * When received, if the handler is enabled the count is checked to the period and the message is sent to chat text area 
	 * 
	 * Sample settings for the MXML CDATA area
	 * 		needwaitPeriod: 10,
	 * 		needwaitSoonThreshold: 10,			  
	 * 		needwaitMessageFirstDefault: "Sorry for the delay, please wait",	// This is the message to be used if the pattern(s) in the needwaitMessageFirst text cannot be resolved
	 * 		needwaitMessageDefault: "Still busy, please wait",					// This is the message to be used if the pattern(s) in the needwaitMessage text cannot be resolved
	 * 		needwaitMessageFirst: "Sorry for the delay, your are <<QUEUE-POSITION>> on the queue, we will be with you in <<SECOND-WAIT-TIME>> seconds.",
	 * 		needwaitMessageFirstSoon: "Sorry for the delay, we will be with you soon.", // This is the message if the wait time is less than needwaitPeriod (in seconds)
	 * 		needwaitMessageFirstMinutes: "Sorry for the delay, we will be with you in about <<MINUTES-ONLY-WAIT-TIME>> minutes.", // This is the message if the wait time is to be shown in minutes only (rounded)
	 * 		needwaitMessageFirstSeconds: "Sorry for the delay, we will be with you in about <<SECOND-WAIT-TIME>> seconds.", // This is the message if the wait time is to be shown in seconds without minutes 
	 * 		needwaitMessageMinutes: "We are still busy, we will be with you in <<MINUTE-WAIT-TIME>> minutes <<SECOND-WAIT-TIME>> seconds.",     
	 * 		needwaitMessage: "We are still busy, we will be with you in <<SECOND-WAIT-TIME>> seconds.", 
	 * 	    needwaitMessageFirst: "Sorry, there are no agents available to help you",
	 * 
	 * Special Cases:
	 * 		MessageFields.KEY_CHAT_WAIT_EST_ASSIGN_TIME == -1        Means no agents available
	 * 		MessageFields.KEY_CHAT_WAIT_EST_ASSIGN_TIME ==  0		 Means agent will be available real soon.   
	 * 																 ... Since this is less than needwaitSoonTheshold (default 10 seconds) 
	 * 																 ... we have this covered
	 * 	Note:
	 * 		cntMessage starts with a count of -1 and increments for each queue message. 
	 * 			If the count is -1 then we know that the message is the first message.
	 * 			The first message has a diffent text then subsequent messages.
	 *      
	 * New behavior for array of messages:
	 * message format: "message1 | {countHint} |{timeShift} // message2 |{countHint} | {timeShift} //  message3 |{countHint} | {timeShift}//..."
	 *  countHint - defines how many times a message will be displayed
	 * timeShift - defines time interval from previous message
	 * if countHint is -1 a message will be displayed infinitely
	 *
	 * Sample:
	 *
	 *  needWaitSequenceMessages: "message1 | 1 |10 // message2 |-1 | 10",
	 *  processingBehavior: "SEQUENCE_MESSAGE_PROCESSING",

	 * @author Fred A Pinn, fpinn@TouchCommerce.com, ahlinski
	 * @mxmlc
	 * @see ClientApplicationMessageHandler
	 */
/**
 * package: com.inq.flash.client.control.messagehandlers
 * class: NeedWaitSequenceMessage
 * root Object
 * @constructor
 */
com.inq.flash.client.control.messagehandlers.NeedWaitSequenceMessage = function() {
};
$hxClasses['com.inq.flash.client.control.messagehandlers.NeedWaitSequenceMessage'] = com.inq.flash.client.control.messagehandlers.NeedWaitSequenceMessage;
/** @private @type {Array} */
com.inq.flash.client.control.messagehandlers.NeedWaitSequenceMessage.__name__ = ["com","inq","flash","client","control","messagehandlers","NeedWaitSequenceMessage"];

/**
 * decrCount
 *
 * $type TFun([],TEnum(Void,[]))
 * public function decrCount()
 * @public
 * @this com.inq.flash.client.control.messagehandlers.NeedWaitSequenceMessage
 * @return {void}
 */
com.inq.flash.client.control.messagehandlers.NeedWaitSequenceMessage.prototype.decrCount = function() {
	/** @type {com.inq.flash.client.control.messagehandlers.NeedWaitSequenceMessage} */
	var _g = this;
	/** @type {number} */
	var _g1 = _g.getCountHit();
	_g.setCountHit(_g1 - 1);
};


/**
 * incrCount
 *
 * $type TFun([],TEnum(Void,[]))
 * public function incrCount()
 * @public
 * @this com.inq.flash.client.control.messagehandlers.NeedWaitSequenceMessage
 * @return {void}
 */
com.inq.flash.client.control.messagehandlers.NeedWaitSequenceMessage.prototype.incrCount = function() {
	/** @type {com.inq.flash.client.control.messagehandlers.NeedWaitSequenceMessage} */
	var _g = this;
	/** @type {number} */
	var _g1 = _g.getCountHit();
	_g.setCountHit(_g1 + 1);
};


/**
 * getCountHit
 *
 * $type TFun([],TInst(Int,[]))
 * private function getCountHit():Int
 * @private
 * @this com.inq.flash.client.control.messagehandlers.NeedWaitSequenceMessage
 * @return {number}
 */
com.inq.flash.client.control.messagehandlers.NeedWaitSequenceMessage.prototype.getCountHit = function() {
	return this.countHit;
};


/**
 * setCountHit
 *
 * $type TFun([{ name => count, t => TInst(Int,[]), opt => false }],TInst(Int,[]))
 * private function setCountHit(count:Int):Int
 * @private
 * @this com.inq.flash.client.control.messagehandlers.NeedWaitSequenceMessage
 * @param {number}  count 
 * @return {number}
 */
com.inq.flash.client.control.messagehandlers.NeedWaitSequenceMessage.prototype.setCountHit = function(count) {
	return this.countHit = count;
};


/**
 * getTimeShift
 *
 * $type TFun([],TInst(Float,[]))
 * private function getTimeShift():Float
 * @private
 * @this com.inq.flash.client.control.messagehandlers.NeedWaitSequenceMessage
 * @return {number}
 */
com.inq.flash.client.control.messagehandlers.NeedWaitSequenceMessage.prototype.getTimeShift = function() {
	return this.timeShift;
};


/**
 * setTimeShift
 *
 * $type TFun([{ name => time, t => TInst(Float,[]), opt => false }],TInst(Float,[]))
 * private function setTimeShift(time:Float):Float
 * @private
 * @this com.inq.flash.client.control.messagehandlers.NeedWaitSequenceMessage
 * @param {number}  time 
 * @return {number}
 */
com.inq.flash.client.control.messagehandlers.NeedWaitSequenceMessage.prototype.setTimeShift = function(time) {
	return this.timeShift = time;
};


/**
 * getNeedWaitMessage
 *
 * $type TFun([],TInst(String,[]))
 * private function getNeedWaitMessage():String
 * @private
 * @this com.inq.flash.client.control.messagehandlers.NeedWaitSequenceMessage
 * @return {string}
 */
com.inq.flash.client.control.messagehandlers.NeedWaitSequenceMessage.prototype.getNeedWaitMessage = function() {
	return this.needWaitMessage;
};


/**
 * setNeedWaitMessage
 *
 * $type TFun([{ name => message, t => TInst(String,[]), opt => false }],TInst(String,[]))
 * private function setNeedWaitMessage(message:String):String
 * @private
 * @this com.inq.flash.client.control.messagehandlers.NeedWaitSequenceMessage
 * @param {string}  message 
 * @return {string}
 */
com.inq.flash.client.control.messagehandlers.NeedWaitSequenceMessage.prototype.setNeedWaitMessage = function(message) {
	return this.needWaitMessage = message;
};

/** @type {number} */
com.inq.flash.client.control.messagehandlers.NeedWaitSequenceMessage.prototype.countHit = null;
/** @type {number} */
com.inq.flash.client.control.messagehandlers.NeedWaitSequenceMessage.prototype.timeShift = null;
/** @type {string} */
com.inq.flash.client.control.messagehandlers.NeedWaitSequenceMessage.prototype.needWaitMessage = null;
/** @type {com.inq.flash.client.control.messagehandlers.NeedWaitSequenceMessage} */
com.inq.flash.client.control.messagehandlers.NeedWaitSequenceMessage.prototype.__class__ = com.inq.flash.client.control.messagehandlers.NeedWaitSequenceMessage;
